(function ($) {
  $(document).ready(function () {
    /* =====
    Logos
  ===== */

    if ($("#rp_section--logos .rp_carousel").length) {
      $("#rp_section--logos .rp_carousel").slick({
        dots: false,
        infinite: true,
        arrows: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              infinite: true,
              slidesToShow: 4,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 767,
            settings: {
              autoplay: true,
              infinite: true,
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              autoplay: true,
              infinite: true,
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }

    /* =====
    Reviews
  ===== */

    if ($("#rp_section--reviews .rp_carousel").length) {
      $("#rp_section--reviews .rp_carousel").slick({
        dots: false,
        infinite: true,
        arrows: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              infinite: true,
              arrows: true,
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 767,
            settings: {
              infinite: true,
              arrows: true,
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }
    /* =====
    Shop Sauces
  ===== */

    if ($("#rp_section--shop-sauces .rp_carousel").length) {
      $("#rp_section--shop-sauces .rp_carousel").slick({
        dots: false,
        infinite: true,
        arrows: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              infinite: true,
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 767,
            settings: {
              infinite: true,
              centerMode: true,
              cssEase: "linear",
              centerPadding: "25%",
              slidesToShow: 1,
              slidesToScroll: 1,
              swipeToSlide: true,
              draggable: true,
            },
          },
        ],
      });
    }

    /* =====
    Shop Sauces
  ===== */

    if ($("#rp_section--shop-tortillas-chips .rp_carousel").length) {
      $("#rp_section--shop-tortillas-chips .rp_carousel").slick({
        dots: false,
        infinite: true,
        arrows: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              infinite: true,
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 767,
            settings: {
              infinite: true,
              centerMode: true,
              centerPadding: "22%",
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }

    /* =====
    Shop Chilis
  ===== */

    if ($("#rp_section--shop-chilis .rp_carousel").length) {
      $("#rp_section--shop-chilis .rp_carousel").slick({
        dots: false,
        infinite: true,
        arrows: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              infinite: true,
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }

    /* =====
      Shop Recipes
    ===== */

    if ($("#rp_section--shop-recipes .rp_carousel").length) {
      $("#rp_section--shop-recipes .rp_carousel").slick({
        dots: false,
        infinite: true,
        arrows: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 500,
            settings: {
              arrows: false,
              dots: true,
              centerMode: true,
              centerPadding: "10%",
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }

    $(".rp_video-elem button").on("click tap", function () {
      var $button = $(this);
      var $thumbnail = $button.prev("img");
      var $video = $button.next("video");
      var $carousel = $button.closest(".rp_carousel");

      $carousel.find("video").each(function () {
        var $video = $(this);
        var $button = $video.prev("button");
        var $thumbnail = $button.prev("img");

        $video[0].pause();
        $video[0].currentTime = 0;

        $button.fadeIn();
        $thumbnail.fadeIn();
      });

      $button.fadeOut();
      $thumbnail.fadeOut();

      $video[0].play();
    });

    /* =====
      Shop Product Recipes (Product Page)
    ===== */

    if ($("#rp_section--shop-product-recipes .rp_carousel").length) {
      $("#rp_section--shop-product-recipes .rp_carousel").slick({
        dots: false,
        infinite: true,
        arrows: false,
        autoplay: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              infinite: true,
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 767,
            settings: {
              infinite: true,
              centerMode: true,
              centerPadding: "10%",
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }

    /* =====
      Product Description (Show More)
    ===== */

    var $btn_view_more = $(".rp_btn-more-details button");

    $btn_view_more.on("click tap", function() {

      var is_show_more = $btn_view_more.attr("data-button") === "show-more";

      if (is_show_more) {
        $btn_view_more.text("Show Less").attr("data-button", "show-less");
        
        $(".rp_product-description-content.truncated").fadeOut(function() {
          $(".rp_product-description-content.full").fadeIn();
        });
        
      } else {
        $btn_view_more.text("Show More").attr("data-button", "show-more");

        $(".rp_product-description-content.full").fadeOut(function() {
          $(".rp_product-description-content.truncated").fadeIn();
        });
        
      }

    });

    $(".header--cart-toggle").on("click tap", function(e) {
      e.preventDefault();
      corner.do("openCart")
    });



    // if (theme.settings.cart_disable_drawer === 'true') {
    //   $(".product-form--add-to-cart").on("click tap", function(e) { 
    //     e.preventDefault();

    //     $("#corner-sticky-atc-cta-button")[0].click();
      
    //   });
    // }

    /* =====
      Loox Rating
    ===== */

    $("body").on("click tap", ".loox-rating-container:not(.loox-rating-carousel)", function() {
      var url = $(this).attr("data-url");

      if (!url) {
        $("html, body").animate({
          scrollTop: $("#looxReviews").offset().top
        }, "slow");
      }

    });
  });
  
})(jQuery);
